/*
 * @Author: benaozhi
 * @Date: 2020-01-03 18:18:20
 * @Description: 认证 store
 */
import { USER_TOKEN, USER_INFO, USER_Type } from '@/config/const'
import { VuexModule, Module, Action, Mutation } from 'vuex-module-decorators'
import { authAPI } from '@/apis'

import { UseLoading } from '@/render/utils/decorators'
import { LocalStorageItem } from '@/render/utils/storage'

// 创建 storage 管理器
const tokenLSI = new LocalStorageItem({ fieldName: USER_TOKEN })
const userLSI = new LocalStorageItem({ fieldName: USER_INFO })
const userTypeLSI = new LocalStorageItem({ fieldName: USER_Type })

@Module({ namespaced: true })
export default class AuthModule extends VuexModule {
  // 令牌
  _token = tokenLSI.get()
  _user = userLSI.get()
  _userType = userTypeLSI.get()

  get token() {
    return this._token
  }
  get isLogin() {
    return !!this._token
  }
  get user() {
    return this._user
  }
  get userType() {
    return this._userType
  }

  @Mutation
  setToken(token) {
    this._token = token
    tokenLSI.set(token)
  }

  @Mutation
  removeToken() {
    this._token = null
    tokenLSI.remove()
  }
  @Mutation
  removeUserType() {
    this._userType = null
    userTypeLSI.remove()
  }

  @Mutation
  setUser(data) {
    this._user = data
    userLSI.set(data)
  }
  @Mutation
  setUserType(data) {
    this._userType = data
    userTypeLSI.set(data)
  }

  // 登录
  @Action()
  @UseLoading('正在登录...')
  async login({ username, password }) {
    // 登录并保存 token
    const result = await authAPI.login({ username, password })
    this.context.commit('setToken', result.data ? result.data.token : null)
    return result
  }
  // 退出登录
  @Action()
  async loginOut() {
    // await authAPI.loginOut()
    this.context.commit('removeToken')
    this.context.commit('removeUserType')
  }
}
